<template>
  <v-layout row>
    <TemplateMetadataDialog :dialog.sync="dialog" v-if="dialog"/>
    <AuditItemsImportDialog
      :dialog.sync="dialogImport"
      :currentAudit="currentTemplate"
      v-if="dialogImport"
    />

    <v-flex xs12>
      <v-card>
        <v-toolbar color="secondary lighten-2" dark>
          <v-toolbar-title>TEMPLATE: {{ currentTemplate.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="editItem(templateId, currentTemplate)">
            <v-icon>edit</v-icon>
          </v-btn>
          <MoreMenu
            v-if="adminview"
            :items="more_menu"
            @itemdelete="deleteItem(templateId)"
            @itemsimport="dialogImport = !dialogImport"
            @itemedit="editItem(templateId, currentTemplate)"
          />
        </v-toolbar>
        <v-layout row wrap>
          <v-flex xs3 d-flex>
            <v-card flat>
              <v-card-title primary-title>Scope</v-card-title>
              <v-card-text style="display: block">
                <span v-if="currentTemplate.scope">Bereich: {{ currentTemplate.scope.join(', ')}}</span>
                <br>
                <span v-if="currentTemplate.standard">Standard: {{ currentTemplate.standard }}</span>
                <br>
                <span
                  v-if="currentTemplate.process"
                >Process: {{ currentTemplate.process.join(', ') }}</span>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs3 d-flex>
            <v-card flat>
              <v-card-title primary-title>Angelegt durch</v-card-title>
              <v-card-text v-if="currentTemplate.created_by.displayName">
                <v-chip v-if="currentTemplate.created_by">
                  <v-avatar>
                    <img :src="currentTemplate.created_by.avatar" alt="Avatar">
                  </v-avatar>
                  {{ currentTemplate.created_by.displayName }}
                </v-chip>
              </v-card-text>
              <v-card-text v-else>{{ currentTemplate.created_by }}</v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs3 d-flex>
            <v-card flat>
              <v-card-title primary-title>Zugeordnete Prozesse</v-card-title>
              <v-card-text>{{ currentTemplate.process | arrayToString }}</v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs3 d-flex>
            <v-card flat>
              <v-card-title primary-title>Tags</v-card-title>
              <v-card-text>{{ currentTemplate.tags | arrayToString }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
// Dialogs
import TemplateMetadataDialog from "@/components/dialogs/TemplateMetadataDialog.vue";
import AuditItemsImportDialog from "@/components/dialogs/AuditItemsImportDialog.vue";

// Snippets/Controls
import MoreMenu from "@/components/snippets/MoreMenu.vue";

// Mixins
import FormattingMixin from "@/components/mixins/FormattingMixin.vue";
import TemplateIdBaseMixin from "@/components/mixins/TemplateIdBaseMixin";

// Store
import { mapActions } from "vuex";
import { api } from "@/store/modules/templates";

export default {
  components: {
    TemplateMetadataDialog,
    AuditItemsImportDialog,
    MoreMenu
  },
  data: () => ({
    dialog: false,
    dialogImport: false,
    more_menu: [
      { title: "Delete Template", event: "itemdelete" },
      { title: "Settings", event: "itemedit" },
      { title: "Import Audit Items", event: "itemsimport" }
    ]
  }),
  created() {
    console.log(
      "Template Created",
      this,
      this.templateId,
      this.currentTemplate
    );
  },
  mixins: [TemplateIdBaseMixin, FormattingMixin],
  computed: {
    currentMetaData() {
      const metadata = [
        {
          field: "name",
          description: "Auditname (computed)",
          value: this.currentTemplate.name
        },
        {
          field: "standard",
          description: "Auditierter Standard",
          value: this.currentTemplate.standard
        },
        {
          field: "type",
          description: "Audit Art",
          value: this.currentTemplate.type
        },
        {
          field: "audited_by",
          description: "Audit Typ",
          value: this.currentTemplate.audited_by
        },
        {
          field: "scope",
          description: "Auditierter Bereich",
          value: this.currentTemplate.scope
        },
        {
          field: "auditor",
          description: "Auditor",
          value: this.currentTemplate.auditor
        },
        {
          field: "planning_date",
          description: "Auditplanungs-Termin",
          value: this.currentTemplate.planning_date
        },
        {
          field: "auditing_date",
          description: "Auditdurchführungs-Termin",
          value: this.currentTemplate.auditing_date
        }
      ];

      return metadata;
    },
    adminview() {
      if (this.$route.query.admin) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.setDialogItem,
      api.actions.setDialogAction,
      api.actions.setAuditId
    ]),
    editItem(audit_id, item) {
      console.log("Template Diag öffnen", audit_id, item);
      this.setDialogItem({ ...item });
      this.setAuditId(audit_id);
      this.setDialogAction("update");
      this.dialog = true;
    }
  }
};
</script>
